import _ from "lodash"
import Channel from "data/websocket/channel"
import CalcProfiler from "data/websocket/event-handlers/calc-profiler"
import propertyService from "data/property"
import socketService, * as eventType from "data/socket"
import { local } from "data/lib/local-json"
import notificationService from "data/notification"

// PropertyChannel manages channel connections and events specific to properties
export default class PropertyChannel extends Channel {
  profiler = new CalcProfiler()

  constructor() {
    super();
    // let property channel know when folder calc finishes so it can clear out the folder-generated profile
    socketService.stream().subscribe(signal => {
      if(signal.eventType === eventType.FOLDER_CALC_FINISHED_EVENT) this.profiler = new CalcProfiler()
    })
  }

  // Join the channel corresponding to the propertyId
  // argument, set up event handlers for the property
  // and reload the property from backend to get updated data
  handlePropertySelection(propertyId) {
    console.log(`CONNECTING TO PROPERTY CHANNEL FOR ID: ${propertyId}`)
    console.log(`CURRENT PROPERTY IS: ${local('property')}`)
    this.join('property', propertyId.toString());
    socketService.newEvent({ eventType: eventType.PROPERTY_SELECTED, event: { propertyId }})

    this.onEvent(event => {
      switch(event.eventType) {
        case eventType.CALC_STARTED:
          socketService.newEvent({ eventType: eventType.CALC_STARTED, event })
          this.profiler = new CalcProfiler();
          setTimeout(() => {
            this.fetchPropertyAndSyncCalcDetail(propertyId)
          }, 1000);
          break;
        case eventType.CALC_FINISHED:
          this.profiler.displayCalcProfile(event);
          this.profiler = new CalcProfiler();
          socketService.newEvent({ eventType: eventType.CALC_FINISHED, event })
          setTimeout(() => {
            this.fetchPropertyAndSyncCalcDetail(propertyId)
          }, 1000);
          break;
        case eventType.CALC_ERROR:
          this.fetchPropertyAndSyncCalcDetail(propertyId)
          socketService.newEvent({ eventType: eventType.CALC_ERROR, event })
          break;
        case eventType.CALC_STATUS:
          this.fetchPropertyAndSyncCalcDetail(propertyId)
          this.profiler.updateCalcProfile(event);
          socketService.newEvent({ eventType: eventType.CALC_STATUS, event: this.profiler.profile })
          break;
        case eventType.PROPERTY_UPDATED:
          this.fetchPropertyAndSyncCalcDetail(propertyId)
          socketService.newEvent({ eventType: eventType.PROPERTY_UPDATED, event })
          break;
        case eventType.RENTROLL_SUMMARY_COMPLETE:
          socketService.newEvent({eventType: eventType.RENTROLL_SUMMARY_COMPLETE, event})
          break;
        case eventType.RENTROLL_REORDER_COMPLETE:
          socketService.newEvent({eventType: eventType.RENTROLL_REORDER_COMPLETE, event})
          break;
        case eventType.PDF_IMPORT_STARTED:
          notificationService.notify({type:"info", message:event.msg['text'], dismiss:5000})
          notificationService.enqueue({
            correlationid: event.msg['correlationid'],
            message: event.msg['notif_text'],
            complete: false
          })
          break;
        case eventType.PDF_IMPORT_ERROR:
          notificationService.notify({type:"danger", message:event.msg['text'], dismiss:5000})
          notificationService.enqueue({
            correlationid: event.msg['correlationid'],
            message: event.msg['notif_text'],
            complete: false
          })
          break;
        case eventType.PDF_IMPORT_FINISHED:
          notificationService.notify({type:"success", message:event.msg['text'], dismiss:5000})
          notificationService.enqueue({
            correlationid: event.msg['correlationid'],
            message: event.msg['notif_text'],
            complete: true
          })
          break;
        default:
          console.warn('PropertyChannel got unknown eventType on:', event)
      }
    });
  }

  // Sync the calc detail from a property to our internal instance
  fetchPropertyAndSyncCalcDetail = propertyId => {
    propertyService.fetchProperty(propertyId)
      .then(property => {
        this.profiler.syncCalcDetail(property)
        socketService.newEvent({ eventType: eventType.PROPCHANNEL_CALC_PROPERTY_SYNC, event: {property} })
      })
  }

  // Channel helper to do a task and resolve a returned promise on matching message, e.g.
  //   propertyChannel.do(fn).thenResoleOnMessage(message => message.taskid == someId).then(next)
  // NB: fn is actually done after registering channel event listener for its completion predicate.
  static do(propertyid, fn) {
    const self = new this()
    self.join('property', propertyid)
    return {
      thenResolveOnMessage: (matcher) => {
        return new Promise((resolve) => {
          let result
          const _matcher = async (event) => {
            if (matcher(event.msg)) {
              // commenting the next line out for now until we can refactor it with something meaningful
              //this.event.off(eventType.PROPERTY_UPDATED, _matcher);
              resolve({...event.msg, _result: await result})
              self.leave()
            }
          }
          self.onEvent(_matcher);
          result = fn()
        })
      }
    }
  }
}